import React from "react";
import TradeReports from "../../AccountMetrics/TradeReports";
import "./TradingDaysAnalysis.scss";
import CandleGraphs from "../../../reusableComponents/CandleGraphs/CandleGraphs";
import { FormatUSD } from "../../../utils/helpers/string";

const TradingDaysAnalysis = ({ trading_days_analysis }) => {
  // Add data validation and default values
  const seriesData = {
    name: "Profit",
    data:
      trading_days_analysis?.average_profit_loss_chart?.avg_profit_loss || [],
    time: trading_days_analysis?.average_profit_loss_chart?.weekday || [],
  };

  // Extract analysis data with fallback values
  const analysisData = trading_days_analysis?.trading_days_analysis || {};
  const {
    number_of_trade = 0,
    average_no_of_trades = 0,
    positive_days = 0,
    avg_positive_days = 0,
    negative_days = 0,
    avg_negative_days = 0,
    number_of_days = 0,
  } = analysisData;

  return (
    <div className="tradingDayAnalysis">
      <div className="days-analysis">
        <div className="trading-days">
          <p className="section-title">Trading Days Analysis</p>
          <div className="whole-container">
            <div className="small-container">
              <h3>Number of Trade</h3>
              <p>{number_of_trade}</p>
            </div>
            <div className="small-container">
              <h3>Avg No. of Trades</h3>
              <p>{average_no_of_trades?.toFixed(2)}</p>
            </div>
            <div className="small-container">
              <h3>Positive Days</h3>
              <p>{positive_days?.toFixed(2)}</p>
            </div>
            <div className="small-container">
              <h3>Average Positive Day</h3>
              <p>{FormatUSD(avg_positive_days)}</p>
            </div>
            <div className="small-container">
              <h3>Negative Days</h3>
              <p>{negative_days?.toFixed(2)}</p>
            </div>
            <div className="small-container">
              <h3>Average Negative Day</h3>
              <p>{FormatUSD(avg_negative_days)}</p>
            </div>
          </div>
        </div>

        <div className="trade-reports">
          <div className="header_Wrapper">
            <h2 className="component-heading">Average Profit / Average Loss</h2>
          </div>
          <div className="chart-box-wrapper">
            <div className="tabs-wrapper tabs-1">
              <div className="chart-box">
                <CandleGraphs
                  data={seriesData}
                  dataSymbol="amount"
                  graphType="amount"
                  title="Weeks"
                  aria-label="Chart showing profit/loss by week"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="trade-charts">
          <TradeReports />
        </div>
      </div>
    </div>
  );
};

export default TradingDaysAnalysis;
